<app-loader [isLoading]="loading()"/>
<div class="main-page overflow-hidden">
    <div class="flex overflow-hidden flex-1">
        <div class="board flex-column overflow-hidden w-100 flex-1">
                <section class="work-board flex-column" #boardSection>
                <div class="flex justify-between a-center">
                    <app-filter-panel (setFilters)="search($event)"/>
                    <button mat-icon-button (click)="refreshData()">
                        <mat-icon>update</mat-icon>
                    </button>
                    <button mat-raised-button [matMenuTriggerFor]="selectedOrdersMenu" [disabled]="!selectedOrders.size" data-testid="edit-trigger-button">
                        <span>Редактировать выделенные</span>
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #selectedOrdersMenu="matMenu">
                        <button mat-menu-item (click)="editSelectedOrders()">
                            Редактировать
                        </button>
                        <button mat-menu-item (click)="deleteOrders()" data-testid="delete-orders-button">
                            Удалить
                        </button>
                    </mat-menu>
                    <button mat-raised-button color="warn" [matMenuTriggerFor]="menu" data-testid="plan-trigger-button">
                        <span>Планировать</span>
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="uploadCSV()" data-testid="upload-csv-button">
                            Загрузить заявки
                        </button>
                        <button mat-menu-item (click)="assignOrders()" data-testid="assign-orders-open-dialog-button">
                            Распределить заявки
                        </button>
                        <button mat-menu-item (click)="cancelDistributedOrders()">
                            Отменить распределенные
                        </button>
                        <button mat-menu-item (click)="changeOrdersStatusToReady()" data-testid="change-order-status-to-ready-button">
                            Отправить распределенные в работу
                        </button>
                        <button mat-menu-item (click)="saveReport()">
                            Отчет по загрузке работников
                        </button>
                    </mat-menu>
                </div>

                <div class="table-container flex-1" #tableContainer>
                        <table>
                            <thead>
                            <tr>
                                <th>
                                    <div class="total-info flex-column">
                                        <div class="flex justify-between">
                                            <app-tasks-count [allWorkersTasks]="assignedOrders"/>
                                            <div class="filters">
                                            @if(showAll) {
                                                <mat-icon id="show" (click)="toggleShowHideAll()">visibility</mat-icon>
                                                    } @else {
                                                <mat-icon id="hide" (click)="toggleShowHideAll()">visibility_off</mat-icon>
                                            }
                                        </div>
                                        </div>
                                        <div>
                                            <span id="active-executors">
                                                Активных сотрудников: {{activeWorkersCount}}
                                            </span>
                                        </div>

                                    </div>
                                </th>
                                <th>
                                    <div class="checkbox-container flex justify-center w-100">
                                        <mat-checkbox
                                            id="master-checkbox"
                                            (change)="toggleAllWorkersSelection($event.checked)"
                                            [checked]="areAllOrdersSelected"
                                            [indeterminate]="someOrdersSelected && !areAllOrdersSelected"
                                            [matTooltip]="'Выбрать все задачи'">
                                        </mat-checkbox>
                                    </div>
                                </th>
                                <th style="z-index: 1;">
                                    <div class="timeline flex justify-between">
                                        @for (time of timelineSteps; track $index) {
                                            <div class="time-step flex-1" [style.width.px]="hourWidth">
                                                |{{time}}
                                            </div>
                                        }
                                        |{{endTime}}
                                    </div>
                                </th>
                            </tr>
                            </thead>
                            <tbody (mouseleave)="setCanDrag(false)">
                                @for (worker of workers; track worker.data.id) {
                                    <tr>
                                        <td [id]="'worker-card-' + worker.data.id" [class.highlighted]="worker.data.id === highlightedWorkerId()">
                                            <div class="worker-info flex j-space-between a-center">
                                                <app-worker-card
                                                    [worker]="worker"
                                                    [workerTasks]="getWorkerTasks(worker.data.id)"
                                                    [showAllExecutorsSignal]="showAllExecutors"
                                                    (changedTasks)="search(queryParams)"
                                                    (showHideExecutors)="showHideExecutors($event)"
                                                    (changedStatus)="search(queryParams)"
                                                    [currentDate]="queryParams['filter.dateFrom']"
                                                />
                                            </div>
                                        </td>
                                        <td>
                                            <mat-checkbox
                                                class="worker-checkbox flex justify-center a-center"
                                                id="checkbox"
                                                (change)="selectAllWorkerOrders(worker.data.id, $event.checked)"
                                                [checked]="areAllWorkerOrdersSelected(worker.data.id)"
                                                [indeterminate]="someWorkerOrdersSelected(worker.data.id) && !areAllWorkerOrdersSelected(worker.data.id)"
                                                [matTooltip]="'Выбрать все задачи'">
                                            </mat-checkbox>
                                        </td>
                                        <td (mouseenter)="setCanDrag(true)" >
                                            <div class="task-board-container flex flex-1 w-100 justify-between p-relative"
                                                 cdkDropList
                                                [id]="'worker-' + worker.data.id"
                                                [style.height]="hideRow(worker.data.id) ? '130px' : '40px'"
                                                 [ngStyle]="{'background': mainPageService.getNonWorkingTimeGradient(worker, startTime, endTime, queryParams)}"
                                                [cdkDropListData]="getWorkerTasks(worker.data.id)"
                                                [cdkDropListConnectedTo]="getConnectedListIds(worker.data.id)"
                                                 (cdkDropListDropped)="drop($event)"
                                                 data-testid="task-board-div">

                                                @if(hiddenExecutors.includes(worker.data.id)) {
                                                    @for (time of timelineSteps; track $index) {
                                                        @for (task of getTasksForSlot(getWorkerTasks(worker.data.id), $index); track $index) {
                                                            <div
                                                                class="order-card mat-elevation-z2 p-absolute flex-1"
                                                                #orderCard
                                                                (click)="toggleOrderSelection(task)"
                                                                (mousedown)="onMouseDown()"
                                                                (mouseup)="onMouseUp()"
                                                                (mouseenter)="onMouseEnter(task.data.id)"
                                                                (mouseleave)="onMouseLeave()"
                                                                [ngStyle]="mainPageService.calculateTaskStyle(task, time, getWorkerTasks(worker.data.id), startTime, endTime, cardWidth)"
                                                            >
                                                                <!-- Блоки-индикаторы -->
                                                                @if (isDrag && isHovered(task.data.id)) {
                                                                    <div class="drop-indicator left"
                                                                         (mouseenter)="setPosition('left')"
                                                                         (mouseleave)="setPosition('')"
                                                                    ></div>
                                                                }
                                                                @if (isDrag && isHovered(task.data.id)) {
                                                                    <div class="drop-indicator right"
                                                                         (mouseenter)="setPosition('right')"
                                                                         (mouseleave)="setPosition('')"
                                                                    ></div>
                                                                }

                                                                <!-- mouseenter - устанавливаем позицию для вставки перетаскиваемой карточки -->
                                                                <!-- mouseleave - сбрасываем позицию при выходе курсора из области индикатора -->

                                                                <button cdkDrag
                                                                        class="mat-elevation-z2 card"
                                                                        [cdkDragData]="task"
                                                                        [class.highlighted]="task.data.id === highlightedOrderId()"
                                                                        [id]="'order-' + task.data.id"
                                                                        [class.selected]="isOrderSelected(task)"
                                                                        data-testid="app-task-card-button"
                                                                >
                                                                    <app-task-card [selectedOrders]="selectedOrders" (isDrag)="$event ? onMouseDown() : onMouseUp()" [task]="task" [smallWidth]="!orderCard.matches(':hover') || isDrag" (taskInfo)="showOrderInfo($event)"/>
                                                                </button>
                                                            </div>
                                                        }
                                                    }
                                                }
                                            </div>
                                        </td>
                                    </tr>
                                }

                            </tbody>
                        </table>
                    </div>

                <div class="hints flex justify-between">
                    @for (status of enumService.enumToArr(OrderStatusEnum); track status) {
                        <div class="hint flex a-center">
                            <div class="status" [ngClass]="'status_' + status.toLowerCase()"></div>
                            {{enumTranslateService.translateStatus(status)}}
                        </div>
                    }
                </div>

            </section>
            <div class="map-resizable-container p-relative flex-column">
                <div class="resize-handle" (mousedown)="startResize($event)">
                    <mat-icon>unfold_more</mat-icon>
                </div>

                @defer (on viewport; prefetch on idle) {
                    <section class="map-section"
                         [style.height.px]="mapHeight()"
                         (mouseenter)="setCanDrag(false)"
                    >
                        <app-map
                            (workerEntered)="markAsTouched('worker-card', $event)"
                            [showFilters]="showFilters()"
                            [hoveredOrderId]="highlightedMapPoint()"
                            (pointTouched)="markAsTouched('order', $event)"
                            (selectionChanged)="multiHighlightedMapPoints($event)"
                            [selectedOrders]="selectedOrdersForMap"
                            #mapComponent
                        ></app-map>
                    </section>
                } @placeholder {
                    <section class="map-section" [style.height.px]="mapHeight()">
                        <div class="flex a-center justify-center h-100" style="height: 100%; opacity: 0.8;">
                            <span>Карта загрузится при прокрутке…</span>
                        </div>
                    </section>
                } @loading {
                    <section class="map-section" [style.height.px]="mapHeight()">
                        <div class="flex a-center justify-center h-100" style="height: 100%;">
                            <app-loader [isLoading]="true"></app-loader>
                        </div>
                    </section>
                } @error {
                    <section class="map-section" [style.height.px]="mapHeight()">
                        <div class="flex a-center justify-center h-100" style="height: 100%; color: #b00020;">
                            Не удалось загрузить карту
                        </div>
                    </section>
                }

            </div>
        </div>
        <section class="orders flex-column" [style.width.px]="showFilters() ? 450 : 40" >
            <button class="menu-button" mat-icon-button type="button" (click)="toggleFilters()">
                <mat-icon>{{ showFilters() ? 'close' : 'menu_open' }}</mat-icon>
            </button>
            @if (showFilters()) {
                <div class="filters">
                    <mat-form-field style="width: 100%">
                        <mat-label>Фильтрация</mat-label>
                        <input matInput [(ngModel)]="filterText" (ngModelChange)="applyFilter()">
                    </mat-form-field>
                </div>
                <div class="flex justify-between">
                    <div class="flex a-center">{{filteredNewOrders.length}} шт.</div>
                    <button mat-button (click)="selectAllOrders(true)">Выбрать все</button>
                    <button mat-button (click)="selectAllOrders(false)">Снять выделение</button>
                    <mat-checkbox [(ngModel)]="showActiveTasks" (change)="addActiveOrdersOnMap()">На карте</mat-checkbox>
                    <button mat-icon-button (click)="sortOrdersByDateFrom(sortDirection, true)">
                        <mat-icon>swap_vert</mat-icon>
                    </button>
                </div>
                <div class="orders-section flex-1 scroll-auto">
                    <div class="order-list flex-column radius"
                         cdkDropList
                         id="newOrdersList"
                         (mouseenter)="setCanDrag(true)"
                         [cdkDropListData]="filteredNewOrders"
                         [cdkDropListConnectedTo]="getWorkerListIds()"
                         (cdkDropListDropped)="drop($event)">

                        @for (task of filteredNewOrders; track task.data.id) {
                            <button cdkDrag
                                    class="mat-elevation-z2 card"
                                    (mouseenter)="onMouseEnter(task.data.id)"
                                    (mouseleave)="onMouseLeave()"
                                    [class.highlighted]="task.data.id === highlightedOrderId()"
                                    [id]="'order-' + task.data.id"
                                    [cdkDragData]="task"
                                    [class.selected]="isOrderSelected(task)"
                                    (click)="toggleOrderSelection(task)"
                                    data-testid="app-task-card-new-button"
                            >
                                <app-task-card (isDrag)="$event ? onMouseDown() : onMouseUp()"  [selectedOrders]="selectedOrders" [task]="task" (taskInfo)="showOrderInfo($event)"/>
                            </button>
                        }
                    </div>
                </div>
            }
        </section>

    </div>
</div>
